// extracted by mini-css-extract-plugin
export default {"headerDiv":"header_headerDiv__SeBEi","words":"header_words__MmcwR"};